import React from "react";
import { Progress, Spinner } from "reactstrap";
import { FaCheckCircle, FaExclamationTriangle } from "react-icons/fa";

const ICON_SIZE = 18;

const ImportProgress = ({
  stage,
  status,
  total_rows,
  processed_rows,
  progress_percentage,
  error_message
}) => {

  const isFailed = status === "failed";

  const isRetrievingActive = stage === "retrieving_file";
  const isRetrievingDone = stage && stage !== "retrieving_file";

  const isImportingActive = stage === "importing_qty";
  const isImportingDone = stage === "upload_complete" && status === "success";

  const isUploadComplete = stage === "upload_complete" && status === "success";

  const safeTotal = parseInt(total_rows) || 0;
  const safeProcessed = parseInt(processed_rows) || 0;
  const safePct = Math.min(parseInt(progress_percentage) || 0, 100);

  const renderIcon = (done, active) => {

    if (isFailed && active)
      return <FaExclamationTriangle color="#dc3545" size={ICON_SIZE} />;

    if (done)
      return <FaCheckCircle color="#28a745" size={ICON_SIZE} />;

    if (active)
      return (
        <Spinner
          size="sm"
          style={{ width: ICON_SIZE, height: ICON_SIZE }}
        />
      );

    return <span style={{ width: ICON_SIZE, height: ICON_SIZE, display: "inline-block" }} />;
  };

  const labelStyle = (done, active) => ({
    color: done || active ? "#212529" : "#adb5bd",
    fontWeight: active ? 600 : "normal"
  });

  const percentStyle = (done, active) => ({
    color: done || active ? "#212529" : "#adb5bd",
    fontWeight: active ? 600 : "normal",
    minWidth: 48,
    textAlign: "right"
  });

  return (
    <div style={{ paddingTop: 40, paddingBottom: 75 }}>

      {/* Retrieving File */}
      <div className="d-flex align-items-center justify-content-between mb-4">

        <div className="d-flex align-items-center" style={labelStyle(isRetrievingDone, isRetrievingActive)}>
          {renderIcon(isRetrievingDone, isRetrievingActive)}
          <span className="ml-2" style={{
                fontSize: 16,
                color: "grey",
              }}>Retrieving File</span>
        </div>

        <span style={percentStyle(isRetrievingDone, isRetrievingActive)}>
          {isRetrievingDone ? "100%" : "0%"}
        </span>

      </div>

      {/* Importing Qty */}

      <div className="mb-4">

        <div className="d-flex align-items-center justify-content-between mb-2">

          <div className="d-flex align-items-center" style={labelStyle(isImportingDone, isImportingActive)}>
            {renderIcon(isImportingDone, isImportingActive)}
            <span 
              className="ml-2"
              style={{
                fontSize: 16,
                color: "grey",
              }}>Importing Qty</span>
          </div>

          <span style={percentStyle(isImportingDone, isImportingActive)}>
            {isImportingDone ? "100%" : isImportingActive ? `${safePct}%` : "0%"}
          </span>

        </div>

        {(isImportingActive || isImportingDone) && (

          <div
            className="position-relative"
            style={{
              height: 14,
              marginLeft: ICON_SIZE + 10
            }}
          >

            <Progress
              value={isImportingDone ? 100 : safePct}
              color="success"
              style={{
                height: 15,
                borderRadius: 6,
                backgroundColor: "#e9ecef"
              }}
            />

            {safeTotal > 0 && (

              <span
                style={{
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  color: "#fff",
                  fontSize: 11,
                  fontWeight: 500
                }}
              >
                {Math.min(safeProcessed, safeTotal)}/{safeTotal}
              </span>

            )}

          </div>

        )}

      </div>

      {/* Upload Complete */}

      <div className="d-flex align-items-center justify-content-between">

        <div className="d-flex align-items-center" style={labelStyle(isUploadComplete, false)}>
          {renderIcon(isUploadComplete, false)}
          <span className="ml-2" style={{
            fontSize: 16,
            color: "grey",
          }}>Upload Complete</span>
        </div>

        <span style={percentStyle(isUploadComplete, false)}>
          {stage === "upload_complete" ? "100%" : "0%"}
        </span>

      </div>

      {isFailed && (

        <div className="mt-3 text-danger">
          <strong>Import failed.</strong>{" "}
          {error_message || "Please try again or contact support."}
        </div>

      )}

    </div>
  );
};

export default React.memo(ImportProgress);
